import { api } from "@/services/api";
import { Country } from "@/types";

export class CountryRepository {
  async findAll(): Promise<Country[]> {
    const response = await api.get("/v1/admin/countries/");

    return response.data;
  }

  async update(
    id: string,
    countryData: {
      name?: string;
      nameAr?: string;
      isVisible?: boolean;
      image?: string;
    },
  ): Promise<Country> {
    const response = await api.patch(`/v1/admin/countries/${id}`, countryData);

    return response.data;
  }

  async add(countryData: {
    name: string;
    nameAr: string;
    image: string;
    id?: string;
    isVisible?: boolean;
  }): Promise<Country> {
    const response = await api.post("/v1/admin/countries", countryData);

    return response.data;
  }
}
